import { render, staticRenderFns } from "./AppointmentFreightUser.vue?vue&type=template&id=c81c8e66&scoped=true"
import script from "./AppointmentFreightUser.vue?vue&type=script&lang=js"
export * from "./AppointmentFreightUser.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFreightUser.vue?vue&type=style&index=0&id=c81c8e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c8e66",
  null
  
)

export default component.exports